import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './SurgicalPro.css';

const SurgicalPro = () => {
    const pricing = [
        { type: "Odontectomy", price: "₱10,000 and UP" },
        { type: "Apicoectomy", price: "₱10,000 - ₱15,000" },
        { type: "Frenectomy", price: "₱10,000 - ₱15,000" },
        { type: "Gingvectomy (per each)", price: "₱15,000" },
    ];

    return (
        <>
         <Header />
            <div className="surpro-container">
                <div className="surpro-content">
                    <h1>SURGICAL PROCEDURE</h1>
                    <p>
                        Odontectomy, or tooth extraction, removes a tooth from its socket. Apicoectomy treats tooth root
                        infections by removing the infected root tip and sealing the root canal. Frenectomy is a procedure
                        to correct tongue-tie or lip-tie by cutting a small piece of tissue restricting movement. Gingivectomy
                        involves removing excess gum tissue to treat gum disease or improve appearance. These procedures are
                        typically performed by dentists or oral surgeons.
                    </p>
                    <h2>Pricing</h2>
                    <table className="surpro-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default SurgicalPro;